/**
 * Modal reutilizable de preview de foto/video con descripción y dictado.
 * Patrón compartido por CapturaFoto, EvidenciaUpload y HallazgoFotosPanel.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Si el modal está visible
 * @param {string} props.previewSrc - URL del blob para preview
 * @param {string} [props.previewType='image'] - 'image' o 'video'
 * @param {string} [props.title='Agregar foto'] - Título del modal
 * @param {boolean} [props.uploading=false] - Si está subiendo (deshabilita botones)
 * @param {Function} props.onSave - Callback al guardar, recibe (descripcion: string)
 * @param {Function} props.onCancel - Callback al cancelar/cerrar
 * @returns {JSX.Element|null}
 */
import React, { useState, useEffect } from 'react';
import InputConDictado from './InputConDictado';

function FotoPreviewModal({
  isOpen,
  previewSrc,
  previewType = 'image',
  title = 'Agregar foto',
  uploading = false,
  onSave,
  onCancel
}) {
  const [descripcion, setDescripcion] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setDescripcion('');
    }
  }, [isOpen]);

  if (!isOpen || !previewSrc) return null;

  const handleSave = () => {
    onSave(descripcion.trim());
  };

  const handleCancel = () => {
    if (!uploading) onCancel();
  };

  return (
    <div className="modal-backdrop" onClick={handleCancel}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close-btn" onClick={handleCancel} disabled={uploading}>
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="modal-body">
          {previewType === 'video' ? (
            <video src={previewSrc} className="captura-modal-img" controls />
          ) : (
            <img src={previewSrc} alt="Vista previa" className="captura-modal-img" />
          )}
          <InputConDictado
            value={descripcion}
            onChange={setDescripcion}
            placeholder="Descripción (opcional)"
            disabled={uploading}
          />
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={handleCancel} disabled={uploading}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={handleSave} disabled={uploading}>
            {uploading
              ? <><i className="fas fa-spinner fa-spin" /> Subiendo…</>
              : <><i className="fas fa-upload" /> Guardar</>
            }
          </button>
        </div>
      </div>
    </div>
  );
}

export default FotoPreviewModal;
